/* LoveinTea - Tea product info (lit-tea-main) */
(function () {
  if (window.__litTea) return;
  window.__litTea = true;

  function fmt(cents, f) {
    cents = Math.round(cents); f = f || '${{amount}}';
    function g(n, d, t, s) { var p = (n / 100).toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(d ? s : ''); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return g(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return g(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return g(cents, 0, '.', ',');
      return g(cents, 2, ',', '.');
    });
  }

  function init(root) {
    if (!root || root.__lt) return;
    root.__lt = true;
    var cfg = {}, variants = [];
    try { cfg = JSON.parse(root.querySelector('[data-lt-config]').textContent); } catch (e) {}
    try { variants = JSON.parse(root.querySelector('[data-lt-variants]').textContent); } catch (e) {}
    var money = function (c) { return fmt(c, cfg.moneyFormat); };
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return [].slice.call(root.querySelectorAll(s)); };

    var form = q('form.lt-form'), idIn = q('[data-lt-id]'), planIn = q('[data-lt-plan]'), cta = q('[data-lt-cta]');
    var packs = qa('.lt-pack'), modes = qa('.lt-mode');
    var state = { vid: idIn ? Number(idIn.value) : null, sub: !!(cfg.plan && cfg.sub) };

    function variant(id) { for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return null; }
    function alloc(v) {
      if (!v || !cfg.plan || !v.selling_plan_allocations) return null;
      for (var i = 0; i < v.selling_plan_allocations.length; i++) if (v.selling_plan_allocations[i].selling_plan_id === cfg.plan) return v.selling_plan_allocations[i];
      return null;
    }
    function priceOf(v) { var a = state.sub ? alloc(v) : null; return a ? a.price : v.price; }
    function radio(list, el) {
      list.forEach(function (b) { var on = b === el; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); if (b.classList.contains('lt-pack')) b.tabIndex = on ? 0 : -1; });
    }

    function render() {
      var v = variant(state.vid); if (!v) return;
      var a = alloc(v), p = priceOf(v);
      if (idIn) idIn.value = v.id;
      if (planIn) { var use = state.sub && a; planIn.disabled = !use; planIn.value = use ? cfg.plan : ''; }
      packs.forEach(function (b) {
        var pv = variant(Number(b.dataset.variant)); if (!pv) return;
        var pp = priceOf(pv), cmp = pv.compare_at_price || 0;
        var pe = b.querySelector('[data-lt-pp]'), ce = b.querySelector('.lt-pack__cmp'), se = b.querySelector('[data-lt-ps]');
        if (pe) pe.textContent = money(pp);
        if (ce) ce.hidden = !(cmp > pp);
        var pct = cmp > pp ? Math.floor((cmp - pp) * 100 / cmp) : 0;
        if (se) se.textContent = pct > 0 ? (cfg.save || '').replace('[pct]', pct) : '';
      });
      var tc = q('[data-lt-top-cmp]'), tp = q('[data-lt-top-price]');
      if (tp) tp.textContent = money(p);
      if (tc) { tc.textContent = money(v.compare_at_price || 0); tc.hidden = !(v.compare_at_price > p); }
      var sp = q('[data-lt-sub-price]'), op = q('[data-lt-once-price]');
      if (sp && a) sp.textContent = money(a.price);
      if (op) op.textContent = money(v.price);
      var st = q('[data-lt-sticky-price]'); if (st) st.textContent = money(p);
      var lbl = q('[data-lt-cta-label]'); if (lbl) lbl.textContent = v.available ? cfg.cta : cfg.soldOut;
      if (cta) cta.disabled = !v.available;
      qa('[data-lt-submit]').forEach(function (b) { b.disabled = !v.available; });
    }

    function pick(id) {
      state.vid = id;
      var v = variant(id);
      try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      if (v && v.featured_media) showMedia(v.featured_media.id);
      render();
    }

    packs.forEach(function (b, i) {
      b.addEventListener('click', function () { radio(packs, b); pick(Number(b.dataset.variant)); });
      b.addEventListener('keydown', function (e) {
        var j = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % packs.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + packs.length) % packs.length;
        if (j > -1) { e.preventDefault(); packs[j].focus(); packs[j].click(); }
      });
    });
    modes.forEach(function (m) {
      var go = function () { radio(modes, m); state.sub = m.dataset.mode === 'sub'; render(); };
      m.addEventListener('click', go);
      m.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });

    /* Chi gui selling_plan cua minh (widget app tu chen vao form bi an + bo qua) */
    if (form) form.addEventListener('formdata', function (e) {
      var v = variant(state.vid), a = alloc(v);
      e.formData.delete('selling_plan');
      if (state.sub && a) e.formData.set('selling_plan', cfg.plan);
      if (v) e.formData.set('id', v.id);
    });
    qa('[data-lt-submit]').forEach(function (b) { b.addEventListener('click', function () { if (cta && !cta.disabled) cta.click(); }); });

    /* Gallery */
    var main = q('[data-lt-main]') || q('.lt-gal__main img');
    var thumbs = qa('.lt-gal__thumb');
    function showThumb(t) {
      if (!t || !main) return;
      main.src = t.dataset.src; main.srcset = t.dataset.srcset; main.removeAttribute('sizes'); main.setAttribute('sizes', '(min-width: 990px) 680px, 100vw');
      thumbs.forEach(function (x) { var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
      var rail = t.parentNode;
      if (rail && rail.scrollTo) rail.scrollTo({ left: Math.max(0, t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
    }
    function showMedia(mid) { for (var i = 0; i < thumbs.length; i++) if (Number(thumbs[i].dataset.mediaId) === mid) return showThumb(thumbs[i]); }
    function step(d) {
      var i = 0; thumbs.forEach(function (t, k) { if (t.classList.contains('is-on')) i = k; });
      if (thumbs.length) showThumb(thumbs[(i + d + thumbs.length) % thumbs.length]);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showThumb(t); }); });
    var pv = q('[data-lt-prev]'), nx = q('[data-lt-next]');
    if (pv) pv.addEventListener('click', function () { step(-1); });
    if (nx) nx.addEventListener('click', function () { step(1); });
    var gm = q('.lt-gal__main'), x0 = null;
    if (gm) {
      gm.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      gm.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); }, { passive: true });
    }

    /* Ngay giao du kien: hom nay + min..max ngay */
    var eta = q('[data-lt-eta]');
    if (eta) {
      var mn = parseInt(eta.dataset.min, 10), mx = parseInt(eta.dataset.max, 10);
      if (!isNaN(mn) && !isNaN(mx)) {
        var o = { weekday: 'short', month: 'short', day: 'numeric' }, d1 = new Date(), d2 = new Date();
        d1.setDate(d1.getDate() + mn); d2.setDate(d2.getDate() + mx);
        try { eta.querySelector('[data-lt-eta-date]').textContent = d1.toLocaleDateString('en-US', o) + ' - ' + d2.toLocaleDateString('en-US', o); eta.hidden = false; } catch (e) {}
      }
    }

    /* Sticky ATC */
    var sticky = q('[data-lt-sticky]');
    if (sticky && cta && 'IntersectionObserver' in window) {
      var sb = sticky.querySelector('button');
      new IntersectionObserver(function (en) {
        var r = en[0].boundingClientRect, show = !en[0].isIntersecting && r.top < 0;
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true'); if (sb) sb.tabIndex = show ? 0 : -1;
      }).observe(cta);
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-lt]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-lt]'); if (r) { r.__lt = false; init(r); } });
})();
